import { z } from "zod";

import { OrderDirection } from "@/constants/orderDirection";

import { TAB_FILTER } from "./-constants";

export const SearchSchema = z.object({
  text: z.string().default(""),
  status: z.nativeEnum(TAB_FILTER).default(TAB_FILTER.INTEGRATIONS),
  pageSize: z.number().default(100),
  pageIndex: z.number().default(0),
  sortColumn: z.enum(["app"]).optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
});

export type SearchSchema = z.infer<typeof SearchSchema>;
